import { Collapse } from "antd";
import { Component } from "react";

import { cn } from "@btnet/utilities-core";

import { BTCollapse } from "commonComponents/btWrappers/BTCollapse/BTCollapse";
import { BTIconCaretRightOutlined } from "commonComponents/btWrappers/BTIcon";
import { BTTitle } from "commonComponents/btWrappers/BTTitle/BTTitle";
import { type IPageSectionProps } from "commonComponents/utilities/PageSection/PageSection";

import "./PageSectionCollapsible.less";

const Panel = Collapse.Panel;

interface IPageSectionCollapsibleProps
    extends Omit<IPageSectionProps, "extra" | "isCollapsible" | "isStickyHeader"> {
    isExpanded?: boolean;
    children: React.ReactNode;
}

export class PageSectionCollapsible extends Component<IPageSectionCollapsibleProps> {
    static defaultProps = {
        className: "",
        removeBodyPadding: false,
    };

    render() {
        const { className, title, children, removeBodyPadding, isExpanded, ...rest } = this.props;

        const pageSectionCollapsibleClass = cn("PageSectionCollapsible", className, {
            removeBodyPadding: removeBodyPadding,
        });

        return (
            <BTCollapse
                data-testid="pageSectionCollapsible"
                bordered={false}
                expandIcon={({ isActive }) => <BTIconCaretRightOutlined rotateRight={isActive} />}
                className={pageSectionCollapsibleClass}
                defaultActiveKey={isExpanded ? "pageSectionContent" : undefined}
                {...rest}
            >
                <Panel
                    key="pageSectionContent"
                    header={
                        <BTTitle level={2} className="pageSectionTitle">
                            {title}
                        </BTTitle>
                    }
                >
                    {children}
                </Panel>
            </BTCollapse>
        );
    }
}
